import {getSchedule} from "./Api";
import React, {useState, useEffect} from "react";
import {WeekCalendar} from "./WeekCalendar";
import {WeekSelector} from "./WeekSelector";
import {Loading} from "./Loading";
import * as t from "./types";
import {Notification} from './Notification';

// should manage api requests, loading states/transitions
// and listen from selector to change the current calendar
// here should also be a menu bar for login or something?
interface MainProps {}
interface IState {
  weeks: any;
  activeWeek: any;
  courseGroups: any;
  notification?: t.INotification;
}
export const MainArea = (props: MainProps) => {
  //const { weeks, courseGroups } = props;
  //const [activeWeek, setActiveWeek] = useState(weeks[0]); //doesnt make any sense. I need to load first..
  const [state, setState]: [IState | null, any] = useState(null);

  // get state from server on initial load
  useEffect(() => {
    if (state === null) {
      getSchedule().then((resp: t.IScheduleResponse) => {
        if (resp.status === "success") {
          let newState: IState = {
            weeks: resp.data.weeks,
            activeWeek: resp.data.weeks[0],
            courseGroups: resp.data.courseGroups,
          };
          if (resp.notification) {
            newState.notification = resp.notification;
          }
          setState(newState);
        } else {
          console.log(`received status: ${resp.status} from server.`);
        }
      }).catch(err => {
        console.error('failed to download sched?');
        console.error(err);
      });
    }
  });

  // callbacks
  const weekSelected = (week: t.IWeek) => {
    const newState: IState = Object.assign({}, state);
    newState.activeWeek = week;
    setState(newState);
  };
  const notifyUpdate = (data: t.IData) => {
    // need to set some state in here to trigger reupdate.
    const newState: IState = {
      activeWeek: state!.activeWeek, //keep same active week
      weeks: data.weeks,
      courseGroups: data.courseGroups,
    };
    setState(newState);
  };

  //render
  if (state === null) {
    return <Loading />;
  }

  const notification = state!.notification ? <Notification title={state!.notification!.title} body={state!.notification!.body} /> : <div />;

  return (
    <div>
      <WeekSelector
        weeks={state!.weeks}
        weekSelected={weekSelected}
        activeWeek={state!.activeWeek}
      />
      <WeekCalendar
        activeWeek={state!.activeWeek}
        courseGroups={state!.courseGroups}
        notifyUpdate={notifyUpdate}
      />
      {notification}
    </div>
  );
};
